<script lang="ts" setup>
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

defineProps({
  hasBack: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(["back"]);

function onClick() {
  emits("back");
}
</script>

<template>
  <div class="login-head login-head__background">
    <div
      v-if="hasBack"
      class="login-head__back"
      data-testid="back-button"
      @click="onClick"
    >
      <FeatherIcon icon="chevron-left" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-head {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &__background {
    min-height: 341px;
    background: url("@/assets/svg/Onboarding/head.svg") no-repeat top;
    background-position-y: calc(env(safe-area-inset-top, 0) + 1rem);
    background-position-y: calc(constant(safe-area-inset-top) + 1rem);
  }

  &__back {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px;
    padding-top: calc(env(safe-area-inset-top, 0) + 10px);
    padding-top: calc(constant(safe-area-inset-top) + 10px);
  }
}
</style>
